import * as C from "@dimforge/rapier3d-compat";
import { ActiveEvents as A } from "@dimforge/rapier3d-compat";
import { defineQuery as a } from "bitecs";
import { TIME_CONSTANTS as I } from "../../core/ecs/constants.js";
import "../../core/ecs/components.js";
import "three";
import "../../core/validation/schemas.js";
import { Transform as d, WorldTransform as m } from "../transforms/components.js";
import "../transforms/systems.js";
import { PhysicsWorld as E, Body as n, Collider as l, CharacterController as f, CharacterMovement as F, ApplyForce as D, ApplyTorque as z, ApplyImpulse as N, ApplyAngularImpulse as q, SetLinearVelocity as k, SetAngularVelocity as L, KinematicMove as $, KinematicRotate as B, TouchedEvent as g, TouchEndedEvent as h, InterpolatedTransform as p, CollisionEvents as x } from "./components.js";
import { DEFAULT_GRAVITY as G, applyCharacterMovement as K, applyForceToEntity as _, applyTorqueToEntity as U, applyImpulseToEntity as H, applyAngularImpulseToEntity as j, setLinearVelocityForEntity as J, setAngularVelocityForEntity as oo, teleportEntity as ro, applyKinematicMove as eo, applyKinematicRotation as to, syncRigidbodyToECS as no, copyRigidbodyToTransforms as so, interpolateTransforms as io, syncBodyQuaternionFromEuler as co, createRigidbodyDescriptor as lo, configureRigidbody as po, createColliderDescriptor as ao } from "./utils.js";
const fo = a([E]), Q = a([n]), uo = a([l]), mo = a([f]), yo = a([
  f,
  F,
  n,
  d
]), go = a([D, n]), ho = a([z, n]), Co = a([N, n]), To = a([q, n]), Eo = a([k, n]), vo = a([L, n]), bo = a([$, n]), wo = a([B, n]), Ro = a([g]), So = a([h]), Y = /* @__PURE__ */ new WeakMap();
function u(o) {
  let e = Y.get(o);
  return e || (e = {
    physicsWorld: null,
    worldEntity: null,
    entityToRigidbody: /* @__PURE__ */ new Map(),
    entityToCollider: /* @__PURE__ */ new Map(),
    entityToCharacterController: /* @__PURE__ */ new Map(),
    colliderToEntity: /* @__PURE__ */ new Map()
  }, Y.set(o, e)), e;
}
const xo = {
  group: "fixed",
  first: !0,
  update: (o) => {
    const e = u(o);
    if (e.physicsWorld) return;
    if (fo(o.world).length === 0) {
      const r = o.createEntity();
      o.addComponent(r, E), e.worldEntity = r, E.gravityX[r] = 0, E.gravityY[r] = G, E.gravityZ[r] = 0;
      const s = new C.World(
        new C.Vector3(
          E.gravityX[r],
          E.gravityY[r],
          E.gravityZ[r]
        )
      );
      s.timestep = I.FIXED_TIMESTEP, e.physicsWorld = s;
    }
  },
  dispose: (o) => {
    const e = Y.get(o);
    e && (e.physicsWorld && e.physicsWorld.free(), e.entityToRigidbody.clear(), e.entityToCollider.clear(), e.entityToCharacterController.clear(), e.colliderToEntity.clear(), Y.delete(o));
  }
}, Yo = {
  group: "fixed",
  after: [xo],
  update: (o) => {
    const e = u(o), t = e.physicsWorld;
    if (t) {
      for (const r of Q(o.world))
        e.entityToRigidbody.has(r) || Xo(r, t, o, e);
      for (const r of uo(o.world))
        e.entityToCollider.has(r) || Zo(r, t, o, e);
      for (const r of mo(o.world))
        e.entityToCharacterController.has(r) || Wo(r, t, e);
    }
  }
};
function Xo(o, e, t, r) {
  const s = new C.Vector3(
    n.posX[o],
    n.posY[o],
    n.posZ[o]
  );
  (n.eulerX[o] !== 0 || n.eulerY[o] !== 0 || n.eulerZ[o] !== 0) && co(o);
  const c = n.rotX[o], i = n.rotY[o], v = n.rotZ[o], b = n.rotW[o], R = Math.sqrt(
    c * c + i * i + v * v + b * b
  );
  if (R < 1e-3)
    throw new Error(
      `Invalid quaternion for Rigidbody entity ${o}: (${c}, ${i}, ${v}, ${b}). Quaternion magnitude is ${R}. Ensure Rigidbody.rotW is initialized (typically to 1 for identity rotation).`
    );
  const Z = new C.Quaternion(c, i, v, b), X = lo(
    n.type[o],
    s,
    Z
  ), S = e.createRigidBody(X);
  po(
    S,
    o,
    n.type[o],
    n.mass[o],
    new C.Vector3(n.velX[o], n.velY[o], n.velZ[o]),
    new C.Vector3(
      n.rotVelX[o],
      n.rotVelY[o],
      n.rotVelZ[o]
    ),
    n.linearDamping[o],
    n.angularDamping[o],
    n.gravityScale[o],
    n.ccd[o],
    n.lockRotX[o],
    n.lockRotY[o],
    n.lockRotZ[o]
  ), r.entityToRigidbody.set(o, S), t.hasComponent(o, d) || (t.addComponent(o, d), d.posX[o] = n.posX[o], d.posY[o] = n.posY[o], d.posZ[o] = n.posZ[o], d.rotX[o] = n.rotX[o], d.rotY[o] = n.rotY[o], d.rotZ[o] = n.rotZ[o], d.rotW[o] = n.rotW[o], d.scaleX[o] = 1, d.scaleY[o] = 1, d.scaleZ[o] = 1), t.hasComponent(o, m) || (t.addComponent(o, m), m.posX[o] = n.posX[o], m.posY[o] = n.posY[o], m.posZ[o] = n.posZ[o], m.rotX[o] = n.rotX[o], m.rotY[o] = n.rotY[o], m.rotZ[o] = n.rotZ[o], m.rotW[o] = n.rotW[o], m.scaleX[o] = 1, m.scaleY[o] = 1, m.scaleZ[o] = 1), t.hasComponent(o, p) || t.addComponent(o, p);
  const T = S.translation(), y = S.rotation();
  p.prevPosX[o] = T.x, p.prevPosY[o] = T.y, p.prevPosZ[o] = T.z, p.posX[o] = T.x, p.posY[o] = T.y, p.posZ[o] = T.z, p.prevRotX[o] = y.x, p.prevRotY[o] = y.y, p.prevRotZ[o] = y.z, p.prevRotW[o] = y.w, p.rotX[o] = y.x, p.rotY[o] = y.y, p.rotZ[o] = y.z, p.rotW[o] = y.w;
}
function Zo(o, e, t, r) {
  const s = r.entityToRigidbody.get(o);
  if (!s || !t.hasComponent(o, n))
    return;
  const w = t.hasComponent(o, x) ? A.COLLISION_EVENTS : A.NONE, c = new C.Vector3(
    l.posOffsetX[o],
    l.posOffsetY[o],
    l.posOffsetZ[o]
  ), i = l.rotOffsetX[o] || 0, v = l.rotOffsetY[o] || 0, b = l.rotOffsetZ[o] || 0;
  let R = l.rotOffsetW[o];
  Math.sqrt(
    i * i + v * v + b * b + R * R
  ) < 1e-3 && (R = 1);
  const X = new C.Quaternion(
    i,
    v,
    b,
    R
  );
  let S = 1, T = 1, y = 1;
  t.hasComponent(o, d) && (S = d.scaleX[o], T = d.scaleY[o], y = d.scaleZ[o]);
  const P = ao(
    l.shape[o],
    l.sizeX[o] * S,
    l.sizeY[o] * T,
    l.sizeZ[o] * y,
    l.radius[o],
    l.height[o],
    l.friction[o],
    l.restitution[o],
    l.density[o],
    l.isSensor[o],
    l.membershipGroups[o],
    l.filterGroups[o],
    c,
    X,
    w
  ), W = e.createCollider(P, s);
  r.entityToCollider.set(o, W), r.colliderToEntity.set(W.handle, o);
}
function Wo(o, e, t) {
  const r = e.createCharacterController(
    f.offset[o]
  );
  r.setMaxSlopeClimbAngle(f.maxSlope[o]), r.setMinSlopeSlideAngle(f.maxSlide[o]), r.setNormalNudgeFactor(1e-4), f.snapDist[o] > 0 ? r.enableSnapToGround(f.snapDist[o]) : r.disableSnapToGround(), r.enableAutostep(
    f.maxStepHeight[o],
    f.minStepWidth[o],
    !!f.autoStep[o]
  ), r.setUp(
    new C.Vector3(
      f.upX[o],
      f.upY[o],
      f.upZ[o]
    )
  ), r.setApplyImpulsesToDynamicBodies(!0), r.setCharacterMass(70), r.setSlideEnabled(!0), t.entityToCharacterController.set(o, r);
}
const Ao = {
  group: "fixed",
  after: [Yo],
  update: (o) => {
    const e = u(o), t = e.physicsWorld;
    if (t) {
      for (const [r, s] of e.entityToCollider)
        o.hasComponent(r, l) || (t.removeCollider(s, !1), e.entityToCollider.delete(r), e.colliderToEntity.delete(s.handle));
      for (const [r, s] of e.entityToRigidbody)
        o.hasComponent(r, n) || (t.removeRigidBody(s), e.entityToRigidbody.delete(r));
      for (const [r, s] of e.entityToCharacterController)
        o.hasComponent(r, f) || (t.removeCharacterController(s), e.entityToCharacterController.delete(r));
    }
  }
}, M = {
  group: "fixed",
  after: [Ao],
  update: (o) => {
    const e = u(o);
    if (!e.physicsWorld || e.worldEntity === null) return;
    const t = E.gravityY[e.worldEntity], r = yo(o.world);
    for (const s of r) {
      const w = e.entityToCharacterController.get(s), c = e.entityToCollider.get(s), i = e.entityToRigidbody.get(s);
      !w || !c || !i || K(
        s,
        w,
        c,
        i,
        o.time.fixedDeltaTime,
        t,
        e.colliderToEntity,
        e.physicsWorld
      );
    }
  }
}, V = {
  group: "fixed",
  after: [M],
  update: (o) => {
    const e = u(o);
    for (const t of go(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && _(t, r, o);
    }
  }
}, O = {
  group: "fixed",
  after: [M],
  update: (o) => {
    const e = u(o);
    for (const t of ho(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && U(t, r, o);
    }
  }
}, Io = {
  group: "fixed",
  after: [V, O],
  update: (o) => {
    const e = u(o);
    for (const t of Co(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && H(t, r, o);
    }
  }
}, Qo = {
  group: "fixed",
  after: [V, O],
  update: (o) => {
    const e = u(o);
    for (const t of To(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && j(t, r, o);
    }
  }
}, Mo = {
  group: "fixed",
  after: [Io, Qo],
  update: (o) => {
    const e = u(o);
    for (const t of Eo(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && J(t, r, o);
    }
    for (const t of vo(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && oo(t, r, o);
    }
  }
}, Vo = {
  group: "fixed",
  after: [Mo],
  update: (o) => {
    const e = u(o);
    for (const t of bo(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && eo(t, r, o);
    }
    for (const t of wo(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && to(t, r, o);
    }
  }
}, Oo = {
  group: "fixed",
  after: [Vo],
  update: (o) => {
    const e = u(o);
    for (const t of Q(o.world)) {
      const r = e.entityToRigidbody.get(t);
      r && ro(t, r);
    }
  }
}, Po = {
  group: "fixed",
  after: [Oo],
  update: (o) => {
    const e = u(o), t = e.physicsWorld;
    if (!t) return;
    const r = new C.EventQueue(!0);
    t.step(r), Fo(r, o, e), r.free();
  }
};
function Fo(o, e, t) {
  o.drainCollisionEvents(
    (r, s, w) => {
      const c = t.colliderToEntity.get(r), i = t.colliderToEntity.get(s);
      c === void 0 || i === void 0 || (w ? (e.hasComponent(c, x) && (e.addComponent(c, g), g.other[c] = i, g.handle1[c] = r, g.handle2[c] = s), e.hasComponent(i, x) && (e.addComponent(i, g), g.other[i] = c, g.handle1[i] = s, g.handle2[i] = r)) : (e.hasComponent(c, x) && (e.addComponent(c, h), h.other[c] = i, h.handle1[c] = r, h.handle2[c] = s), e.hasComponent(i, x) && (e.addComponent(i, h), h.other[i] = c, h.handle1[i] = s, h.handle2[i] = r)));
    }
  );
}
const _o = {
  group: "setup",
  update: (o) => {
    for (const e of Ro(o.world))
      o.removeComponent(e, g);
    for (const e of So(o.world))
      o.removeComponent(e, h);
  }
}, Uo = {
  group: "fixed",
  after: [Po],
  update: (o) => {
    const e = u(o);
    for (const [t, r] of e.entityToRigidbody)
      o.hasComponent(t, n) && (no(t, r, o), so(t, o));
  }
}, Ho = {
  group: "simulation",
  first: !0,
  update: (o) => {
    const e = o.scheduler.getAccumulator() / I.FIXED_TIMESTEP;
    io(o, e);
  }
};
export {
  Qo as ApplyAngularImpulsesSystem,
  V as ApplyForcesSystem,
  Io as ApplyImpulsesSystem,
  O as ApplyTorquesSystem,
  M as CharacterMovementSystem,
  _o as CollisionEventCleanupSystem,
  Vo as KinematicMovementSystem,
  Ao as PhysicsCleanupSystem,
  Yo as PhysicsInitializationSystem,
  Ho as PhysicsInterpolationSystem,
  Uo as PhysicsRapierSyncSystem,
  Po as PhysicsStepSystem,
  xo as PhysicsWorldSystem,
  Mo as SetVelocitySystem,
  Oo as TeleportationSystem
};
//# sourceMappingURL=systems.js.map
